import React from 'react';
import UzyToolWebSearch from './UzyToolWebSearch';
import UzyToolCommand from './UzyToolCommand';
import UzyToolDefault from './UzyToolDefault';

/**
 * 标签渲染注册表
 * key: 标签名（对应 segment.type 或顶层 XML 标签名）
 * value: 渲染组件，接收 content 和 attrs
 */
const TAG_REGISTRY: Record<string, React.FC<{ content: string; attrs?: Record<string, string> }>> = {
  web_search: ({ content }) => <UzyToolWebSearch content={content} />,
  command: ({ content }) => <UzyToolCommand content={content} />,
  // uzy_tool type="terminal" 的内容是 <command>...</command>，提取后渲染
  terminal: ({ content }) => {
    const m = content.match(/<command>([\s\S]*?)<\/command>/);
    return <UzyToolCommand content={m ? m[1].trim() : content} />;
  },
};

/**
 * 根据标签名查找组件，找不到返回 UzyToolDefault
 */
export function getTagComponent(type: string): React.FC<{ content: string; attrs?: Record<string, string> }> {
  return TAG_REGISTRY[type] ?? (({ content }) => <UzyToolDefault content={content} />);
}

/**
 * 所有需要在流式输出时缓冲的标签名集合（供后端白名单参考，前端解析用）
 */
export const BUFFERED_TAG_NAMES = Object.keys(TAG_REGISTRY).concat(['uzy_tool']);
